import React from "react";
import "./App.css";
import { AppProvider } from "./context/AppContext";
import MainLayout from "./components/MainLayout";
import { ConfigProvider } from "antd";
import { UI_COLORS } from "./config";
import "@ant-design/v5-patch-for-react-19";
function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: UI_COLORS.primary,
          colorError: "#cf1322",
        },
      }}
    >
      <AppProvider>
        <MainLayout />
      </AppProvider>
    </ConfigProvider>
  );
}

export default App;
